import React, { useState, useEffect, useCallback } from 'react'
import { throttle } from 'lodash'
import { useHistory } from 'react-router-dom'
import { getIataInfo , getAirportList } from '../_services/airport'
import moment from 'moment'
import useQuery from '../hooks/useQuery'
import { getPropertyList } from '../_services/property'
import 'tippy.js/dist/tippy.css'
import Section from '../layout/Section'
import { GrPowerReset, GrFilter } from 'react-icons/gr'
import FilterModal from '../components/FilterModal'
import ProductCard, { calculateRoomAvgPrice } from '../components/RoomCard'
import { DropdownRange, DropdownList, DropdownListUnique } from '../components/DropDown'
import PropertyListingMap from '../components/PropertyListingMap'
import Header from '../front/Header'
import Footer from '../front/Footer'
import { getCoords } from '../utils/utility'
import { useAuth } from '../context/authContext'
import { usePropertyFilter } from '../context/propertyFilterContext'
import { toast } from 'react-toastify'
import { SearchTopBar } from '../components/SearchTopbar'
import { MobileNavOptions } from '../components/MobileNavOptions'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { constant } from '../_config/constant'
import { Helmet } from 'react-helmet';

const bookingTypeList = ['All','Cold bed', 'Hot bed']
const HOT = 'Hot bed'
const COLD = 'Cold bed'
const FLEXIBLE = 'Flexible'
const ENTIREPLACE = 'Entire Place'

function PropertyListing() {
    
    console.log("here")

    const url = new URL(window.location.href); // Get current URL
    const segments = url.pathname.split('/'); // Split path by "/"
    var locationCode = segments[segments.length - 1]; // Get last segment 
    
    if(locationCode == "property-listing" )
    {
        locationCode = null ;
    }
    
    const [airportCodeUrl, setAirportCodeUrl] = useState(locationCode)
   
    const { user } = useAuth()
    const { updateFilter } = usePropertyFilter()
    const query = useQuery()
    const [sorting, setSorting] = useState('')
    const [globalBookingType, setGlobalBookingType] = useState(query.get('bookingType') || bookingTypeList[0])
    const [airportName, setAirportName] = useState(query.get('airportName') || '')
    const [fetchingProperty, setFetchingProperty] = useState(true)
    const [fetchingLocation, setFetchingLocation] = useState(true)
    const [latlong, setLatLong] = useState(null)
    
    const [filterOptions, setFilterOptions] = useState({
        listing_type: [],
        property_type: [],
        profession: [],
        amenities: [],
        latlng: [],
        gender: [],
        price: [0, 1001],
        stayLimit: [1, 30],
        radiusToAirport: [0, 50],
    })

    const [propertyList, setPropertyList] = useState([])
    const [filterModal, setFilterModal] = useState(false)
    const [propertyMap, setPropertyMap] = useState(false)
    const history = useHistory()

    async function fetchProperty(filter, fetchingLocation) {
        setFetchingProperty(true)
        try {
            if (!fetchingLocation && filter.hasOwnProperty('airportLocation')) {
                const res = await getPropertyList(filter)
                if (res.data.status) {
                    setPropertyList(res.data.data)
                    updateFilter(filter)
                } else {
                    toast.error(res.data.message)
                }
                setFetchingProperty(false)
            }
        } catch (error) {
        } finally {
            setFetchingProperty(false)
        }
    }

    function handleFilterReset() {
        window.location = 'property-listing?bookingType=Hot+bed'
    }
    const [airportDetails, setAirportDetails] = useState({
        name: '',
        iata: '',
    });
    const [airportlist, setAirportList] = useState([]);
    
    const fetchAirport = async (term) => {
        try {
            setAirportList([]); // Clear the list before fetching
            getAirportList(
                term,
                (data) => {
                    
                    setAirportList(data.airports); // Updates asynchronously
                    
                },
                () => {
                    setAirportList([]);
                    setAirportDetails({ name: '' });
                }
            );
        } catch (error) {
            console.log('AirportCodeError', error);
        }
    };
    const throtteledFetchProperty = useCallback(throttle(fetchProperty, 1000), [])

    function filterPrice(property) {
        let searchBookingType = query.get('bookingType')
        if (property.rentalType === ENTIREPLACE) {
            if (property.bookingType === COLD || (property.bookingType === FLEXIBLE && searchBookingType === COLD)) {
                return {
                    str: `${property.perMonthPrice}/ month`,
                    price: property.perMonthPrice,
                    suffix: 'Per month',
                }
            } else if (property.bookingType === HOT || (property.bookingType === FLEXIBLE && searchBookingType === HOT)) {
                return {
                    str: `${property.perNightPrice}/ night`,
                    price: property.perNightPrice,
                    suffix: 'Per night',
                }
            }
        } else {
            return calculateRoomAvgPrice(property?.sleepingArrangements || [], searchBookingType, property.bookingType, property.rentalType, property)
        }
    }

    useEffect(() => {
        
        
        setFetchingProperty(true)
        const newSearchParam = new URLSearchParams(history.location.search)
        if (newSearchParam.has('iata') || airportCodeUrl) {
            
            if(newSearchParam.has('iata') )
            {
                history.push({
                    pathname: '/property-listing/'+newSearchParam.get('iata'),
                    search: newSearchParam.toString(),
                })
            }

            if(airportCodeUrl)
            {
                
                getAirportList(
                    airportCodeUrl,
                    (data) => {
                        console.log(data,"dataa-111111")  
                        if(data?.airports[0])
                        {

                            console.log(data,"dataa-111")  
                            setFilterOptions((e) => ({
                                ...e,
                                airportLocation: true,
                                airportName: data?.airports[0]?.iata,
                                latlng: [data?.airports[0]?.lng, data?.airports[0]?.lat],
                            }))
                        }
                        
                        
                        setAirportName(data.airports[0]?.name);
                       
                    },
                    () => {
                        setAirportList([]);
                        setAirportDetails({ name: '' });
                    }
                );
              
            }
            
        } else {
            
        history.push({
                pathname: '/property-listing',
                search: newSearchParam.toString(),
            })
        }
        //newSearchParam.set('bookingType', globalBookingType)

    }, [globalBookingType])

 


   // Fetch airport when `iata` changes
    useEffect(() => {
        const iataCode = query.get('iata');
        if (iataCode) {
          
            fetchAirport(iataCode);
        }
    }, [query]); // Runs when `query` updates


   
    
    
// Wait for `airportlist` to update before setting airport name & metadata
// useEffect(() => {
//     if (airportlist.length > 0) {
//         const airportName = airportlist[0]?.name;
//         setAirportName(airportName);
        

//         if (airportName) {
//             document.title = `${airportName} Crashpads - Crewmates App`;

//             let metaDescription = document.querySelector("meta[name='description']");
//             if (!metaDescription) {
//                 metaDescription = document.createElement("meta");
//                 metaDescription.name = "description";
//                 document.head.appendChild(metaDescription);
//             }
//             metaDescription.content = `Find an affordable crash pad near ${airportName}. Hosting for flight attendants, pilots …`;

//             return () => {
//                 document.title = "Crewmates App: Crashpads Finder for Flight Crew and Pilots";
//                 if (metaDescription) {
//                     document.head.removeChild(metaDescription);
//                 }
//             };
//         }
//     }
// }, [airportlist]); // Runs when `airportlist` updates

// Handle airportName from query (Separate useEffect)
// useEffect(() => {
//     const airportName = query.get('airportName');
//     if (airportName) {
//         document.title = `${airportName} Crashpads - Crewmates App`;

//         let metaDescription = document.querySelector("meta[name='description']");
//         if (!metaDescription) {
//             metaDescription = document.createElement("meta");
//             metaDescription.name = "description";
//             document.head.appendChild(metaDescription);
//         }
//         metaDescription.content = `Find an affordable crash pad near ${airportName}. Hosting for flight attendants, pilots …`;

//         return () => {
//             document.title = "Crewmates App: Crashpads Finder for Flight Crew and Pilots";
//             if (metaDescription) {
//                 document.head.removeChild(metaDescription);
//             }
//         };
//     }
// }, [query]); // Runs when `query` updates

        // Caconical link 
        useEffect(() => {
            
                 // Create or update the canonical link tag
                 let link = document.querySelector("link[rel='canonical']");
                 if (!link) {
                     link = document.createElement("link");
                     link.rel = "canonical";
                     document.head.appendChild(link);
                 }
                 const url = new URL(window.location.href);
                const baseUrl = `${url.origin}${url.pathname}`;
                const iata = url.searchParams.get("iata");
                if(iata)
                {
                    var newHref = `${baseUrl}?iata=${iata}`;
                }
                else{
                    var newHref = `${baseUrl}`;
                }
                
                 link.href = newHref;
                 
                //  let link = document.querySelector("link[rel='canonical']");
                //  if (!link) {
                //      link = document.createElement("link");
                //      link.rel = "canonical";
                //      document.head.appendChild(link);
                //  }
                //  link.href = window.location.href;
                 // Cleanup function
                 return () => {
                 
                     // Remove the canonical link tag if it exists
                     if (link) {
                         document.head.removeChild(link);
                     }
                 };   
            }, []);

    useEffect(() => {
        const arr = propertyList.sort(function (a, b) {
            let nameA = a.listingName.toLowerCase()
            let nameB = b.listingName.toLowerCase()
            if (sorting === 'Z-A') {
                if (nameA < nameB) return 1
                if (nameA > nameB) return -1
            } else if (sorting === 'A-Z') {
                if (nameA > nameB) return 1
                if (nameA < nameB) return -1
            } else if (sorting === 'Reviews') {
                if (a.totalReview < b.totalReview) return 1
                if (a.totalReview >= b.totalReview) return -1
            } else if (sorting === 'TopRated') {
                if (a.rating < b.rating) return 1
                if (a.rating >= b.rating) return -1
            } else if (sorting === 'AirportClosest') {
                if (a.mile < b.mile) return -1
                if (a.mile >= b.mile) return 1
            } else if (sorting === 'LowHigh') {
                if (filterPrice(a).price < filterPrice(b).price) return -1
                if (filterPrice(a).price >= filterPrice(b).price) return 1
            } else if (sorting === 'HighLow') {
                if (filterPrice(a).price > filterPrice(b).price) return -1
                if (filterPrice(a).price <= filterPrice(b).price) return 1
            }
            return 0
        })

        setPropertyList([...arr])
    }, [sorting])

    useEffect(() => {
        const tommorow = new Date()
        tommorow.setDate(new Date().getDate() + 1)
        
     
        if(airportCodeUrl)
        {

            getAirportList(
                airportCodeUrl,
                (data) => {
                   
                    if(data?.airports[0])
                    {
                        setLatLong( [data?.airports[0]?.longitude, data?.airports[0]?.latitude])
                        console.log("dataa22-111--airport",latlong)  
                        
                    }
                },
                () => {
                    setAirportList([]);
                    setAirportDetails({ name: '' });
                }
            );
    
            console.log( "dataa22-111as===latlong ",latlong )
            var filterRequest = {
                ...filterOptions,
                price: [filterOptions['price'][0], filterOptions['price'][1] > 1000 ? '1000+' : filterOptions['price'][1]],
                radiusToAirport: [
                    filterOptions['radiusToAirport'][0],
                    filterOptions['radiusToAirport'][1] > 100 ? '100+' : filterOptions['radiusToAirport'][1],
                ],
                userId: user.id,
                latlng:latlong,
                stayLimit: query.get('bookingType') === 'Cold bed' || query.get('bookingType') === 'Flexible' ? filterOptions['stayLimit'] : [],
                checkIn: moment(query.get('checkIn') || new Date() + '').format('L'),
                checkOut: moment(query.get('checkOut') || tommorow + '').format('L'),
                booking_type: query.get('bookingType') || bookingTypeList[0],
            }

        }
        else
        {
            var filterRequest = {
                ...filterOptions,
                price: [filterOptions['price'][0], filterOptions['price'][1] > 1000 ? '1000+' : filterOptions['price'][1]],
                radiusToAirport: [
                    filterOptions['radiusToAirport'][0],
                    filterOptions['radiusToAirport'][1] > 100 ? '100+' : filterOptions['radiusToAirport'][1],
                ],
                userId: user.id,
                stayLimit: query.get('bookingType') === 'Cold bed' || query.get('bookingType') === 'Flexible' ? filterOptions['stayLimit'] : [],
                checkIn: moment(query.get('checkIn') || new Date() + '').format('L'),
                checkOut: moment(query.get('checkOut') || tommorow + '').format('L'),
                booking_type: query.get('bookingType') || bookingTypeList[0],
            }

        }
       
        console.log("dataa-111asdsfilrt"  ,filterRequest )
        console.log('testing throttle call')
        throtteledFetchProperty(filterRequest, fetchingLocation)
       
    }, [filterOptions, fetchingLocation, user])

    useEffect(() => {
        const locationQuery = async () => {
            try {
                setFetchingLocation(true)
                const iata = query.get('iata')
                console.log(iata , "iata---")
                if (iata) {
                    getIataInfo(iata, (data) => {
                        const coords = {
                            lat: data.airport.latitude,
                            lng: data.airport.longitude,
                        }

                        setFilterOptions((e) => ({
                            ...e,
                            airportLocation: true,
                            airportName: query.get('iata'),
                            latlng: [coords.lng, coords.lat],
                        }))
                    })
                } else {
                    const pos = await getCoords()

                    const coords = {
                        lat: pos.coords.latitude,
                        lng: pos.coords.longitude,
                    }
                    console.log(pos , "iata---pos")
                    setFilterOptions((e) => ({
                        ...e,
                        airportLocation: false,
                        airportName: null,
                        latlng: [coords.lng, coords.lat],
                    }))
                }
            } catch (error) {
                toast.error('Please allow location sharing to show properties nearby.', { toastId: 'pleas_allow_location_error' })
                navigator.permissions
                    .query({
                        name: 'geolocation',
                    })
                    .then(function (result) {})
                setFilterOptions((e) => ({
                    ...e,
                    airportLocation: false,
                    airportName: null,
                    latlng: [],
                }))
            } finally {
                setFetchingLocation(false)
            }
        }

        if (query.get('airportName')) {
            setAirportName(query.get('airportName'))
        } else {
            setAirportName('')
        }

        locationQuery()
    }, [query])


    // meta 111
  
//meta

    return (
        <>
            <Header />
            {filterModal && (
                <FilterModal
                    title="Filters"
                    formData={filterOptions}
                    onClose={() => setFilterModal(false)}
                    onSubmit={(e) => {
                        setFilterModal(false)
                        setFilterOptions({ ...e })
                    }}
                />
            )}
            <Section className="px-4 mt-16 lg:mt-24">
                <MobileNavOptions setGlobalBookingType={setGlobalBookingType} />
                <SearchTopBar setGlobalBookingType={setGlobalBookingType} />
                <div className="my-4 hidden md:flex flex-wrap gap-y-3 gap-x-2 items-center justify-start  space-x-2  w-full scrollbar-hide p-2 ">
                    <button
                        onClick={() => setFilterModal(!filterModal)}
                        className="px-4  p-2 shadow-md rounded-full flex text-gray-600 justify-between text-xs  items-center ring-1 ring-gray-200"
                    >
                        <GrFilter size={18} className="mr-2 text-gray-600 " /> Filter
                    </button>
                    <button
                        onClick={handleFilterReset}
                        className="px-4  p-2 shadow-md rounded-full flex text-gray-600 justify-between text-xs  items-center ring-1 ring-gray-200"
                    >
                        <GrPowerReset size={16} className="mr-2 text-gray-600 " /> Reset
                    </button>
                    <div className="hidden md:flex items-center flex-wrap justify-start gap-2.5 ">
                        <DropdownList
                            data={[
                                { key: 'Crashpad', value: 'Crashpad' },
                                { key: 'Entire Place', value: 'Entire Place' },
                            ]}
                            title={`Listing Type (${filterOptions['listing_type'].length})`}
                            id="listing_type"
                            value={filterOptions['listing_type']}
                            setValue={setFilterOptions}
                        />
                        <DropdownList
                            data={[
                                { key: 'House', value: 'House' },
                                { key: 'Apartment', value: 'Apartment' },
                                { key: 'Hotel', value: 'Hotel' },
                            ]}
                            title={`Property Type  (${filterOptions['property_type'].length})`}
                            id="property_type"
                            value={filterOptions['property_type']}
                            setValue={setFilterOptions}
                        />

                        <DropdownList
                            data={[
                                {
                                    key: 'Flight Attendant Only',
                                    value: 'Flight Attendant Only',
                                },
                                { key: 'Pilot Only', value: 'Pilot Only' },
                                {
                                    key: 'Flight Attendant and Pilot',
                                    value: 'Flight Attendant and Pilot',
                                },
                                {
                                    key: 'All Airline Professionals',
                                    value: 'All Airline Professionals',
                                },
                            ]}
                            title={`Profession (${filterOptions['profession'].length})`}
                            id="profession"
                            value={filterOptions['profession']}
                            setValue={setFilterOptions}
                        />
                        <DropdownRange
                            onChange={(val) => setFilterOptions((e) => ({ ...e, price: val }))}
                            value={filterOptions['price']}
                            title={`$${filterOptions['price'][0]}-$${filterOptions['price'][1] > 1000 ? `1000+ ` : filterOptions['price'][1]}`}
                            prefix={'$'}
                            min={0}
                            max={1001}
                        />
                        <DropdownRange
                            onChange={(val) => setFilterOptions((e) => ({ ...e, radiusToAirport: val }))}
                            value={filterOptions['radiusToAirport']}
                            title={`${filterOptions['radiusToAirport'][0]}mi-${
                                filterOptions['radiusToAirport'][1] > 100 ? '100+ ' : filterOptions['radiusToAirport'][1]
                            }mi`}
                            subHeading="Radius"
                            suffix={'mi'}
                            min={0}
                            max={101}
                        />
                        <div className="hidden lg:block">
                            <DropdownListUnique
                                data={[
                                    { key: 'Number of Reviews', value: 'Reviews' },
                                    { key: 'Closest to Airport', value: 'AirportClosest' },
                                    { key: 'Top Rated', value: 'TopRated' },
                                    {
                                        key: 'Low-High',
                                        value: 'LowHigh',
                                    },
                                    {
                                        key: 'High-Low',
                                        value: 'HighLow',
                                    },
                                ]}
                                value={sorting}
                                unique
                                setValue={setSorting}
                                title="Sort"
                            />
                        </div>
                    </div>
                </div>
                <div className="grid grid-cols-12 gap-4 mt-4 ">
                    <div className="flex flex-col  md:flex-row  md:justify-between mb-3 md:items-center col-span-full  lg:col-span-8">
                        <div className="flex justify-center gap-1.5 md:justify-start items-center">
                            <div className="md:hidden ">
                                <DropdownListUnique
                                    data={[
                                        { key: 'Number of Reviews', value: 'Reviews' },
                                        { key: 'Closest to Airport', value: 'AirportClosest' },
                                        { key: 'Top Rated', value: 'TopRated' },
                                        {
                                            key: 'Low-High',
                                            value: 'LowHigh',
                                        },
                                        {
                                            key: 'High-Low',
                                            value: 'HighLow',
                                        },
                                    ]}
                                    value={sorting}
                                    unique
                                    setValue={setSorting}
                                    title="Sort"
                                />
                            </div>
                            <button
                                className="px-3.5 my-2 p-2 space-x-0 md:hidden shadow-md rounded-full flex text-gray-600 justify-between text-xs  items-center ring-1 ring-gray-400 "
                                onClick={() => setPropertyMap((e) => !e)}
                            >
                                Toggle Map
                            </button>
                            <button
                                onClick={() => setFilterModal(!filterModal)}
                                className="px-3.5 my-2 p-2  md:hidden shadow-md rounded-full flex text-gray-600 justify-between text-xs  items-center ring-1 ring-gray-400 "
                            >
                                <GrFilter size={18} className="mr-2 text-gray-600 " /> Filter
                            </button>
                        </div>
                    </div>
                </div>
                {airportName && !fetchingProperty && (
                    <h1 className="text-2xl mb-4 text-primary-blue font-medium">
                        {airportName}, {propertyList.length}{' '}
                        {propertyList.length === 0 ? 'properties' : propertyList.length === 1 ? 'property' : 'properties'} found
                    </h1>
                )}
                <div className="grid grid-cols-12 relative gap-4 overflow-y-auto lg:h-80-screen">
                    <div className="col-span-full md:col-span-8 overflow-y-scroll scrollbar-hide">
                        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 px-2 pb-4 min-h-[300px]">
                            {fetchingProperty ? (
                                Array.from({ length: 6 }).map((_, index) => (
                                    <div key={index} className="p-0">
                                        <Skeleton height={250} style={{ borderRadius: '1.5rem 1.5rem 0 0' }} />
                                        <Skeleton height={20} width={`60%`} style={{ marginTop: '10px' }} />
                                        <Skeleton height={20} width={`40%`} style={{ marginTop: '10px' }} />
                                        <Skeleton height={20} width={`80%`} style={{ marginTop: '10px' }} />
                                    </div>
                                ))
                            ) : Boolean(propertyList.length) ? (
                                propertyList.map((el, ind) => {
                                    return (
                                        <React.Fragment key={ind}>
                                            <ProductCard
                                                searchBookingType={query.get('bookingType')}
                                                lat={filterOptions['latlng'][1]}
                                                lng={filterOptions['latlng'][0]}
                                                airportName={query.get('iata')}
                                                property={el}
                                            />
                                        </React.Fragment>
                                    )
                                })
                            ) : (
                                <>
                                    {fetchingProperty === false && propertyList.length === 0 && (
                                        <p className="text-xl text-primary-blue text-center my-44  col-span-full">
                                            Crewmates will soon be arriving at your airport domicile!{' '}
                                            <a
                                                className="underline cursor-pointer font-bold"
                                                href="https://www.facebook.com/groups/crewmatescrashpads/"
                                            >
                                                Join our Facebook group
                                            </a>{' '}
                                            to connect with hosts.
                                        </p>
                                    )}
                                </>
                            )}
                        </div>
                    </div>

                    <div
                        className={`row-start-1 md:row-start-auto scrollbar-hide overflow-scroll  col-span-full  md:col-span-4 h-full ${
                            propertyMap ? ' absolute h-full w-full z-[200]' : ' '
                        }`}
                    >
                        <div className="h-full w-full relative">
                            {query.get('bookingType')  ?
                            <PropertyListingMap
                                propertyList={propertyList}
                                filterOptions={filterOptions}
                                lat={filterOptions['latlng'][1]}
                                lng={filterOptions['latlng'][0]}
                                mapkey={propertyList.length > 0 ? propertyList[0].id : 'ee'}
                            />
                            :
                            <>
                            {/* remove in casse of all  */}
                            <PropertyListingMap
                                propertyList={propertyList}
                                filterOptions={filterOptions}
                                lat={filterOptions['latlng'][1]}
                                lng={filterOptions['latlng'][0]}
                                mapkey={propertyList.length > 0 ? propertyList[0].id : 'ee'}
                            />
                            </>
                            }
                            
                        </div>
                    </div>
                </div>
            </Section>
            <Footer />
        </>
    )
}

export default PropertyListing
